/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Earningsfilterall2Inputs */

const en_earningsfilterall2 = /** @type {(inputs: Earningsfilterall2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All`)
};

const de_earningsfilterall2 = /** @type {(inputs: Earningsfilterall2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle`)
};

/**
* | output |
* | --- |
* | "All" |
*
* @param {Earningsfilterall2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const earningsfilterall2 = /** @type {((inputs?: Earningsfilterall2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Earningsfilterall2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_earningsfilterall2(inputs)
	return de_earningsfilterall2(inputs)
});
export { earningsfilterall2 as "earningsFilterAll" }